import api from '@/js/services/api';

export default {
    //user list

    getUsersList(filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }

        return api().get('/master-admin/settings/users/get?' + searchParams.toString())
    },

    updateStatus(userId, status) {
        return api().put(`/master-admin/settings/users/${userId}/status/update`, {status})
    },

    delete(id) {
        return api().delete(`/master-admin/settings/users/${id}/delete`);
    },

    //user item

    updateUserPersonalInfo(id, form) {
        return api().put(`/master-admin/settings/users/${id}/update`, form);
    },
    uploadPhoto(id, formData) {
        return api().post(`/master-admin/settings/users/${id}/add-photo`, formData)
    },

    updatePermissions(user_id, permissions) {
        return api().post(`/master-admin/user/${user_id}/permissions/apply`, {permissions})
    },

    getListOfNotifications(userId) {
        return api().get(`/master-admin/settings/users/${userId}/notifications/get` )
    },

    updateNotifications(user_id, notifications) {
        return api().put(`/master-admin/settings/users/${user_id}/notifications/update`, notifications)
    },

    getListOfAdminComments(userId,filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }

        return api().get(`/master-admin/settings/users/${userId}/notes/get?` + searchParams.toString())
    },

    getListOfNotesOnAdmin(userId, filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }

        return api().get(`/master-admin/settings/users/${userId}/notes-on-admin/get?` + searchParams.toString())
    },

    updateComment(commentId, comment) {
        return api().put(`/master-admin/settings/users/${commentId}/notes-on-admin/update`, {comment})
    },

    deleteComment(userId, comment_id) {
        return api().delete(`/master-admin/settings/users/${userId}/notes-on-admin/delete`, {comment_id});
    },

    addNewComment(userId, comment) {
        return api().post(`/master-admin/settings/users/${userId}/notes-on-admin/store`, {comment})
    },



    //new user

    saveNewUser(form) {
        return api().post(`/master-admin/settings/users/store`, form);
    },
}
